var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-container',{attrs:{"fill-height":"","justify-center":""}},[_c('c-progress-circular',{attrs:{"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }